var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationIdBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69 70H11c-1.654 0-3-1.346-3-3V31c0-1.654 1.346-3 3-3h19v2H11c-.552 0-1 .449-1 1v36c0 .551.448 1 1 1h58c.552 0 1-.449 1-1V31c0-.551-.448-1-1-1H50v-2h19c1.654 0 3 1.346 3 3v36c0 1.654-1.346 3-3 3",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M28 34h24v-2H28zM40 16c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zm0 6c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 33h-2V18c0-3.309-2.691-6-6-6s-6 2.691-6 6v15h-2V18c0-4.411 3.589-8 8-8s8 3.589 8 8v15",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 42c-3.028 0-4 1.093-4 4.5 0 2.667 1.402 5.5 4 5.5s4-2.833 4-5.5c0-3.407-.972-4.5-4-4.5zm0-2c5.318 0 6 3.474 6 6.5 0 2.04-.587 3.84-1.572 5.165L36 55.42V58c0 2.168-1.374 4-3 4H17c-1.626 0-3-1.832-3-4v-2.58l6.572-3.755C19.587 50.34 19 48.54 19 46.5c0-3.026.682-6.5 6-6.5zm0 14a5.22 5.22 0 01-2.926-.89L16 56.58V58c0 1.224.703 2 1 2h16c.297 0 1-.776 1-2v-1.42l-6.074-3.47A5.22 5.22 0 0125 54z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M57 46h9v-2h-9zM38 46h17v-2H38zM49 42h17v-2H49zM38 42h9v-2h-9zM40 60h24v-6H40v6zm-2 2h28V52H38v10z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M43 58h2v-2h-2zM47 58h2v-2h-2zM51 58h2v-2h-2zM55 58h2v-2h-2zM59 58h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationIdBadge;